document.addEventListener("alpine:init", () => {
  Alpine.data("submenu", (hoverEnable = true, anchorModifiers = "") => {
    anchorModifiers = anchorModifiers && "." + anchorModifiers;
    return {
      hover: hoverEnable,
      _opened: new Set(),
      isOpen(id) {
        return this._opened.has(id);
      },
      closingTimers: new Array(),
      open(id) {
        this._opened.forEach((e) => this.close(e));
        clearTimeout(this.closingTimers[id]);
        this._opened.add(id);
      },
      close(id) {
        clearTimeout(this.closingTimers[id]);
        this._opened.delete(id);
      },
      closeLater(id) {
        this.closingTimers[id] = setTimeout(() => {
          this.close(id);
        }, 300);
      },
      toggle(id) {
        this.isOpen(id) ? this.close(id) : this.open(id);
      },
      container: {
        "x-data": "{ id: $id('submenu') }",
        "@mouseenter.prevent"() {
          this.hover && this.open(this.id);
        },
        "@mouseleave.prevent"() {
          this.hover && this.closeLater(this.id);
        },
        ":id"() {
          return this.id;
        },
      },
      trigger: {
        "x-ref": "trigger",
        "@click.prevent"() {
          this.hover ? this.open(this.id) : this.toggle(this.id);
        },
        "@click.outside.throttle.1000ms"() {
          this.close(this.id);
        },
        "@touchend.throttle.prevent"() {
          this.toggle(this.id);
        },
        ":aria-expanded"() {
          return this.isOpen(this.id);
        },
      },
      item: {
        ":aria-hidden"() {
          return !this.isOpen(this.id);
        },
        "x-show"() {
          return this.isOpen(this.id);
        },
        "@keydown.window.escape"() {
          this.close(this.id);
        },
        // "x-trap"() {
        //     return this.isOpen(this.id)
        // },
        "x-transition:enter": "transition ease-out duration-300 transform",
        "x-transition:enter-start": "opacity-0 -translate-y-2",
        "x-transition:enter-end": "opacity-100 translate-y-0",
        "x-transition:leave": "transition ease-out duration-300",
        "x-transition:leave-start": "opacity-100",
        "x-transition:leave-end": "opacity-0",
        [`x-anchor${anchorModifiers}`]: "$refs.trigger",
      },
    };
  });
  Alpine.data("lazyLoadScript", (urlScript) => ({
    loadScript: false,
    url: urlScript,
    scriptSrc: "",
    load() {
      !this.loadScript &&
        ((this.scriptSrc = this.url),
        Alpine.nextTick(() => {
          this.loadScript = true;
        }));
    },
  }));

  Alpine.data("toMainPage", () => ({
    handleClick(e) {
      if (window.location.pathname !== "/") {
        return;
      }

      e.preventDefault();

      if (window.location.hash) {
        history.replaceState(
          null,
          document.title,
          window.location.pathname + window.location.search,
        );
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  }));

  Alpine.magic("nowGetTime", (el, { Alpine }) => {
    return new Date().getTime();
  });
});
